import { Component, OnInit } from '@angular/core';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { IProperties } from '../Interfaces/IProperties';
import { PropertiesService } from '../services/properties-services';
import { Router } from '@angular/router';
import { NotificationService } from '../../../../core/services/notification/notification.service';

declare var $: any;

@Component({
	selector: 'app-contact',
	templateUrl: './contact.component.html',
	styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
	listData: IProperties[];
	nameOwner: string;
	emailOwner: string;
	nameSup: string;
	emailSup: string;
	loading = false;
	constructor(
		private propertiesService: PropertiesService,
		private notificationService: NotificationService,
		private router: Router,
	) {}
	
	ngOnInit() 
	{
		this.loading = true;
		const component = this;
		$(".btnReload").click(function(){
			component.ValidatePermission();
		});
		this.ValidatePermission();
	}

	ValidatePermission()
	{
		this.loading = true;
		if (localStorage.getItem('pksite') != undefined)
			this.getAllContactProperties();
		else 
			this.router.navigateByUrl('/main/without-permission');
	}

	getAllContactProperties() {
		this.GetNameOwner();
	}

	GetEmailSup() {
		this.loading = true;
		this.propertiesService.GetPropertyByName('EMAIL_SUP').subscribe(
		(result: TransactionResult<IProperties[]>) => {
			this.loading = false;
			if (result.success) {
				result.data.forEach((x) => {
					this.emailSup = x.propertyvalue;
				});
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error: any) => {
			this.loading = false;
			this.ErrorAlert(error);
		});
	}

	GetNameSup() {
		this.loading = true;
		this.propertiesService.GetPropertyByName('NAME_SUP').subscribe(
		(result: TransactionResult<IProperties[]>) => {
			this.loading = false;
			if (result.success) {
				result.data.forEach((x) => {
					this.nameSup = x.propertyvalue;
				});
				this.GetEmailSup();
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error: any) => {
			this.loading = false;
			this.ErrorAlert(error);
		});
	}

	GetEmailOwner() {
		this.loading = true;
		this.propertiesService.GetPropertyByName('EMAIL_OWNER').subscribe(
		(result: TransactionResult<IProperties[]>) => {
			this.loading = false;
			if (result.success) {
				result.data.forEach((x) => {
					this.emailOwner = x.propertyvalue;
				});
				this.GetNameSup();
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error: any) => {
			this.loading = false;
			this.ErrorAlert(error);
		});
	}
	GetNameOwner() {
		this.loading = true;
		this.propertiesService.GetPropertyByName('NAME_OWNER').subscribe(
		(result: TransactionResult<IProperties[]>) => {
			this.loading = false;
			if (result.success) {
				result.data.forEach((x) => {
					this.nameOwner = x.propertyvalue;
				});
				this.GetEmailOwner();
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error: any) => {
			this.loading = false;
			this.ErrorAlert(error);
		});
	}

	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
  }
}
